import type { Schema } from '@wix/wix-data-schema-types';
import { CATALOG_PLUGIN_ID } from '@wix/wix-data-schema-types';

export const isCatalogCollection = (collection?: Schema) =>
  Boolean(collection?.plugins?.[CATALOG_PLUGIN_ID]);
